import { Stack, SxProps, Theme, useTheme } from '@mui/material';
import { ReactNode } from 'react';

/**
 * Container component that provides theme-based CSS variables for SVG coloring.
 *
 * This component sets up CSS custom properties that can be consumed by SVG files using var():
 * - --primary-color: maps to theme.palette.dataVisualizationPrimary.main
 * - --secondary-color: maps to theme.palette.dataVisualizationSecondary.main
 * - --negative-color: maps to theme.palette.dataVisualizationNegative.main
 *
 * Example SVG usage:
 * <path fill="var(--primary-color, fallback)" />
 */
interface SVGVariableContainerProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export function SVGVariableContainer({
  children,
  sx,
}: SVGVariableContainerProps) {
  const theme = useTheme<Theme>();

  return (
    <Stack
      sx={{
        '--primary-color': theme.palette.dataVisualizationPrimary.main,
        '--secondary-color': theme.palette.dataVisualizationSecondary.main,
        '--tertiary-color': theme.palette.dataVisualizationTertiary.main,
        '--negative-color': theme.palette.dataVisualizationNegative.main,
        ...sx,
      }}
    >
      {children}
    </Stack>
  );
}
